'use strict';

import LoreServiceInterface from '../interfaces/ilore-service';

export default class LoreHTTPService extends LoreServiceInterface {
  constructor(http, config) {
    super()
    this.http = http;
    this.config = config;
  }
  getAllLore() {
    return this.http.get(this.config.api.getAllLore);
  }
  getLoreById() {
    return this.http.get(this.config.api.getLoreById);
  }
  addLore(lore) {
    return this.http.post(this.config.api.addLore, null, null, lore);
  }
  updateLore(lore) {
    return this.http.patch(this.config.api.updateLore, {
      id: lore.id
    }, null, lore);
  }
}
